import script from "./FlexibleProductInterface.vue?vue&type=script&setup=true&lang=ts"
export * from "./FlexibleProductInterface.vue?vue&type=script&setup=true&lang=ts"

import "./FlexibleProductInterface.vue?vue&type=style&index=0&id=79174e0e&scoped=true&lang=css"
import "./FlexibleProductInterface.vue?vue&type=style&index=1&id=79174e0e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79174e0e"]])

export default __exports__